import React, { PureComponent } from 'react';
import IO from 'socket.io-client';
import sockets from '../tools/serverDispatchSockets';

function log(message, ...args) {
    console.log(`[Socket] ${message}`, ...args);
}

const logData = event => data => log(event, data);

const config = {
    port: 9963,
    url: 'localhost',
};

class Home extends PureComponent {
    state = {
        socket: undefined,
    };

    componentDidMount() {
        const socket = IO.connect(`${config.url}:${config.port}`);
        socket.on('version', data => {
            log(`Connected (v${data.version}): ${config.url}:${config.port}`);
        });

        for (let i = 0; i < sockets.length; i += 1) {
            const { events } = sockets[i];
            for (let j = 0; j < events.length; j += 1) {
                const event = events[j];
                socket.on(event, logData(event));
            }
        }

        this.setState({ socket });
    }

    onEmit = event => () => {
        const { socket } = this.state;

        socket.emit(event);
    }

    renderEvents(events) {
        return events.map(event => (
            <button key={event} onClick={this.onEmit(event)}>{event}</button>
        ));
    }

    renderSockets() {
        return sockets.map(s => (
            <div key={s.name}>
                <h2>{s.name}</h2>
                { this.renderEvents(s.events) }
            </div>
        ));
    }

    render() {
        return (
            <div>
                <h1>DISPATCH SOCKET WPT MOCK</h1>
                { this.renderSockets() }
            </div>
        );
    }
}

export default Home;
